<template>
  <div id="sidebar" class="menu-side" :class="{ 'menu-show': isCollapse }">
    <VuePerfectScrollbar class="scroll-area" :settings="settings">
      <!-- @ps-scroll-y="scrollHanle"  -->
      <div>
        <el-menu unique-opened>
          <el-menu-item
            :index="menu.linkName"
            v-for="menu in sidebar"
            :key="menu.title"
            v-if="displayMenuItem(menu.submenus, menu.permission)"
          >
            <router-link v-bind:to="'/' + menu.linkName">
              <svgicon
                :icon="menu.icon"
                width="22"
                height="18"
                color="#848484"
                class="mr-4"
              ></svgicon>
              {{ menu.title }}
              <i
                class="el-icon-warning ml-5"
                v-if="menu.meta && examsGetter && examsGetter.length"
              ></i>
            </router-link>
          </el-menu-item>
          <el-submenu
            :index="menu.title"
            v-else-if="displayMenuItem(null, menu.permission)"
          >
            <template slot="title">
              <svgicon
                :icon="menu.icon"
                width="22"
                height="18"
                color="#848484"
                class="mr-4"
              ></svgicon>
              <span class="text-uppercase submenuTitle">{{ menu.title }}</span>
            </template>
            <el-menu-item-group
              v-for="submenu in menu.submenus"
              :key="submenu.title"
            >
              <el-menu-item
                v-if="displayMenuItem(submenu.childs, submenu.permission)"
                :index="submenu.title"
              >
                <router-link
                  v-bind:to="submenu.linkName"
                  class="text-capitalize"
                >
                  <svgicon
                    :icon="submenu.icon"
                    width="22"
                    height="18"
                    color="#848484"
                    class="mr-4"
                  ></svgicon>
                  {{ submenu.title }}
                </router-link>
              </el-menu-item>
              <el-submenu
                :index="submenu.title"
                v-else-if="displayMenuItem(null, submenu.permission)"
              >
                <template slot="title">
                  <svgicon
                    :icon="submenu.icon"
                    width="22"
                    height="18"
                    color="#848484"
                    class="mr-4"
                  ></svgicon>
                  <span class="text-uppercase submenuTitle">{{
                    submenu.title
                  }}</span>
                </template>
                <el-menu-item
                  :index="child.title"
                  v-for="child in submenu.childs"
                  :key="child.title"
                >
                  <router-link
                    v-bind:to="child.linkName"
                    class="text-capitalize"
                  >
                    <svgicon
                      :icon="child.icon"
                      width="22"
                      height="18"
                      color="#848484"
                      class="mr-4"
                    ></svgicon>
                    {{ child.title }}
                  </router-link>
                </el-menu-item>
              </el-submenu>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item
            :index="page.identifier"
            v-for="page in Pages"
            :key="page.title"
            v-if="page.identifier"
          >
            <a
              :href="'https://' + page.target_url"
              v-if="page.target_url"
              target="_blank"
            >
              <svgicon
                icon="custompage"
                width="22"
                height="18"
                color="#848484"
                class="mr-4"
              ></svgicon>
              {{ page.title }}
            </a>
            <router-link v-else :to="'/page/' + page.identifier">
              <svgicon
                icon="custompage"
                width="22"
                height="18"
                color="#848484"
                class="mr-4"
              ></svgicon>
              {{ page.title }}
            </router-link>
          </el-menu-item>
        </el-menu>
      </div>
    </VuePerfectScrollbar>
    <el-row type="flex" class="terms-container column-direction">
      <el-col class="text-center">
        <div v-html="this.$translation('b2b_terms_simple')"></div>
      </el-col>
    </el-row>
    <!-- powered By echo logo -->
    <el-row type="flex" class="echoLogo column-direction">
      <el-col>
        <p class="text-center follow-us-title">
          {{ $translation('b2b_follow_us') }}
        </p>
      </el-col>
      <el-col>
        <el-row type="flex" class="text-center">
          <el-col>
            <a href="https://el-gr.facebook.com/gregorys.gr/" target="_blank"
              ><img
                src="@/assets/images/facebook.svg"
                alt="facebook"
                height="24"
            /></a>
          </el-col>
          <el-col>
            <a href="https://www.instagram.com/gregorysgr/" target="_blank"
              ><img
                src="@/assets/images/instagram.svg"
                alt="instagram"
                height="24"
            /></a>
          </el-col>
          <el-col>
            <a
              href="https://www.linkedin.com/company/gregory's-food-service-group-s.a"
              target="_blank"
              ><img
                src="@/assets/images/linkedin.svg"
                alt="linkedin"
                height="24"
            /></a>
          </el-col>
        </el-row>
      </el-col>
      <el-col>
        <div>
          <p class="text-center">
            ECHO B2B
            <span class="version">v. 1.01</span>
          </p>
        </div>
        <div class="powered">
          <p class="text-center">
            powered by
            <span>
              <svgicon
                icon="logo-echo"
                width="50"
                height="50"
                color="#b8b8b8"
                class="mr-4"
              ></svgicon>
            </span>
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import '@/compiled-icons/';
import svgicon from 'vue-svgicon';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'sidebar',
  components: {
    svgicon,
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 90
      },
      windowWidth: 0,
      windowHeight: 0
    };
  },
  computed: {
    ...mapGetters('data', ['azureUserGetter']),
    ...mapGetters('data', ['userRoleGetter']),
    ...mapGetters('menu', {
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      isCollapse: 'getMenuStatusGetter'
    }),
    ...mapGetters('menu', {
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      showOrderDetails: 'showOrderDetailsGetters'
    }),
    ...mapGetters('menu', {
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      overlay: 'getOverlayGetter'
    }),
    ...mapGetters('menu', {
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      isMobile: 'isMobileGetter'
    }),
    ...mapGetters('menu', {
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      showTicketDetails: 'showTicketDetailsGetter'
    }),
    ...mapGetters('data', {
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      examsGetter: 'examsGetter'
    }),
    ...mapGetters('data', ['hostname']),
    ...mapState('data', {
      UserType: state => state.UserData.type
    }),
    ...mapState('data', {
      Pages: state => state.Pages
    }),
    ...mapState('data', {
      sidebar: state => state.Sidebar
    })
  },
  watch: {
    windowWidth() {
      if (this.windowWidth > 1219) {
        this.$store.state.menu.openedMenu = true;
        this.$store.state.menu.mobile = false;
      } else {
        this.$store.state.menu.openedMenu = false;
        this.$store.state.menu.mobile = true;
      }
    },
    // $route function is closing the menu sidebar, on route change, if the window size is less that 1200px
    $route() {
      // alert(this.$route.name)
      /**
       * * close menu sidebar on page change
       */
      if (this.$store.state.menu.mobile === true) {
        this.setMenuStatus(false);
        this.setOverlayStatus(false);
      }
      /**
       * * close order details on page change
       */
      if (this.showOrderDetails === true) {
        this.setOrderDetailsStatus(false);
      }
      /**
       * * close ticket details on page change
       */
      if (this.showTicketDetails === true) {
        this.setTicketDetailsStatus(false);
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);
      // console.log(this.$store.state.menu.openedMenu)
      // Init
      this.getWindowWidth();
      this.getWindowHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  },
  methods: {
    ...mapMutations('menu', {
      setMenuStatus: 'SET_MENU_STATUS'
    }),
    ...mapMutations('menu', {
      setOverlayStatus: 'SET_OVERLAY_STATUS'
    }),
    ...mapMutations('menu', {
      setTicketDetailsStatus: 'SET_SHOW_TIKET_STATUS'
    }),
    ...mapMutations('menu', {
      setOrderDetailsStatus: 'SET_SHOW_ORDER_STATUS'
    }),
    displayMenuItem(submenus, permission) {
      if (this.azureUserGetter) {
        return (
          (submenus == null && permission.includes(this.userRoleGetter)) ||
          (submenus == null && permission.includes('azureuser'))
        );
      } else {
        return submenus == null && permission.includes(this.userRoleGetter);
      }
    },
    getWindowWidth: function() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight: function() {
      this.windowHeight = document.documentElement.clientHeight;
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  display: block;
}
</style>
<style lang="scss">
@import '../assets/scss/main.scss';
#sidebar {
  .el-menu-item i {
    color: #f00808;
  }
  text-align: left;
  height: 100vh;
  //   width: 270px;
  transition: all 0.2s;
  background-color: #ffffff;
  z-index: 9999;
  margin-top: 60px;
  position: fixed;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  //   overflow-y: scroll;
  .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    background-color: var(--main-color);
  }
  .scroll-area {
    //   position: fixed;
    margin: auto;
    height: 65vh;
    width: 270px;
    background-color: #ffffff;
  }
  .el-menu {
    padding-top: 5px;
  }
  .terms-container {
    position: fixed;
    bottom: 200px;
    margin-top: 0;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    a {
      color: var(--main-color);
    }
  }
  .echoLogo {
    font-size: 10.2px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ababab;
    position: fixed;
    bottom: 50px;
    left: 40px;
    margin-top: 0;
    &.column-direction {
      flex-direction: column;
    }
    .follow-us-title {
      font-size: 14px;
      font-weight: 800;
    }
    .version {
      padding: 5px;
      border-radius: 3.1px;
      background-color: #d8d8d8;
      font-size: 10.2px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;
    }
    .powered {
      margin-top: -20px;
      margin-left: 21px;
    }
    .social-media-list {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
  }
  .el-menu {
    border-right: none;
  }
}

a {
  text-decoration: inherit;
  color: #5b5b5b;
}

.menu-side {
  position: fixed;
  top: 0;
  left: -270px;
  padding: 0;
  list-style: none;
  background-color: rgba(0, 0, 3, 0.8);
  z-index: 1000;
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
}
.menu-show {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
}

.router-link-active {
  text-decoration: inherit;
  color: var(--main-color);
  font-weight: bold;
  svg path {
    fill: var(--main-color) !important;
  }
}
.el-aside {
  color: var(--main-color);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  // ul
  //     {
  //       padding-top: 10px;
  //     }
}
.el-menu-item {
  border-left: 4px solid transparent !important;
  font-size: 12.5px !important;
  padding-left: 10px !important;
}
.el-menu-item.is-active {
  font-weight: bold !important;
  color: var(--main-color) !important;
  border-left: 4px solid var(--main-color) !important;
}
.el-menu--collapse {
  width: 0px !important;
}
.el-menu-item {
  text-transform: uppercase;
}
.submenuTitle {
  font-size: 13px;
  color: #5a5a5a;
}
.el-submenu {
  border-left: 4px solid transparent;
  .el-submenu__title {
    padding-left: 10px !important;
  }
  .el-menu--inline {
    padding-left: 20px;
  }
}
.el-submenu.is-active.is-opened {
  .el-submenu__title {
    svg:first-child path {
      fill: var(--main-color) !important;
    }
  }
  border-left: 4px solid var(--main-color) !important;
  .mainIcon {
    color: var(--main-color) !important;
  }
  .el-menu-item.is-active {
    font-weight: bold !important;
    color: #03a7fa !important;
    border-left: 4px solid transparent !important;
    //   .submenuTitle
    // {
    //   font-weight: bold !important;
    //   color: var(--main-color) !important;
    // }
  }
  .submenuTitle {
    color: var(--main-color) !important;
    font-weight: bold !important;
  }
}
// .el-submenu.is-opened{
//   border-left: 4px solid var(--main-color) !important;
//   .mainIcon
//    {
//      color: var(--main-color) !important;
//    }
//   .submenuTitle
//   {
//     font-weight: bold !important;
//     color: var(--main-color) !important;
//   }
//   .el-submenu__title
//   {
//      svg:first-child path
//   {
//     fill:var(--main-color) !important;
//   }
//   }
// }
@media (max-width: 1200px) {
  .menu-side {
    position: absolute;
    overflow-y: hidden;
    top: 0;
    //  height: 100vh;
  }
}
@media (max-width: 970px) {
  #sidebar.collapse {
    width: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarNew.vue